import React from 'react'
import {Link} from "react-router-dom";
import Navbar from '../inc/Navbar';

function Miniket() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
<br/>
       
        <div className='exportindian'>
            <div className="album py-1">
                <div className="container mt-3">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Miniket Rice</li>
                        </ol>
                    </nav>
                </div>
                </div>
            </div>
            <br/>

            <br/>
            <div className="album py-1">
            <div className="container mt-3">
            <h>Update soon</h>
            </div>
            </div>
            <br/>
            <br/>
    </div>
  )
}

export default Miniket